import React from "react";


export function SocialIcon({ name }: { name: string }) {
    const n = name.toLowerCase();
    if (n.includes("facebook")) {
        return (
            <svg viewBox="0 0 24 24" className="size-6 fill-current" aria-hidden>
                <path
                    d="M22 12a10 10 0 1 0-11.5 9.9v-7H7.6V12h2.9V9.7c0-2.8 1.7-4.3 4.2-4.3 1.2 0 2.5.2 2.5.2v2.8h-1.4c-1.4 0-1.8.9-1.8 1.8V12h3.1l-.5 2.9h-2.6v7A10 10 0 0 0 22 12z" />
            </svg>
        );
    }
    if (n.includes("twitter") || n.includes("x")) {
        return (
            <svg viewBox="0 0 24 24" className="size-6 fill-current" aria-hidden>
                <path d="M3 3l7.4 9.6L3.2 21h3.2l5-6 3.9 6H21l-7.6-10L20.6 3h-3.2l-4.5 5.4L9.3 3H3z" />
            </svg>
        );
    }
    return (
        <svg viewBox="0 0 24 24" className="size-6 fill-current" aria-hidden>
            <path
                d="M3.9 12a5 5 0 0 1 5-5h3v2h-3a3 3 0 0 0 0 6h3v2h-3a5 5 0 0 1-5-5zm6-1h4v2h-4v-2zm5.1-4h3a5 5 0 0 1 0 10h-3v-2h3a3 3 0 0 0 0-6h-3V7z" />
        </svg>
    );
}
